<template>
  <div :id="componentId" class="sp1-guest-showcase" :style="showcaseStyle">
    <div class="sp1-guest-list flex-row">
      <a
        v-for="(guest, idx) in guests"
        :key="idx"
        :class="['sp1-guest-item', 'flex-col', { 'is-link': guest.jumpType === 2 }]"
        href="javascript:;"
        @click.prevent="handleClick(guest)"
      >
        <img
          class="sp1-guest-image"
          referrerpolicy="no-referrer"
          :src="guest.imageUrl"
        />
        <div class="sp1-guest-text flex-col">
          <span class="sp1-guest-name">{{ guest.name }}</span>
          <span class="sp1-guest-intro">{{ guest.introduction }}</span>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GuestShowcase',
  props: {
    componentId: {
      type: String,
      default: 'sp_one_module_6'
    }
  },
  data() {
    return {
      backgroundColor: 'rgba(255, 255, 255, 1)',
      guests: [
        {
          imageUrl: require('../assets/img/FigmaDDSSlicePNGa1953558fb341f2cea548f218709eada.png'),
          name: '张 超',
          introduction: '《中国品牌》杂志社社长',
          jumpType: 1,
          linkAddress: ''
        },
        {
          imageUrl: require('../assets/img/FigmaDDSSlicePNGa1953558fb341f2cea548f218709eada.png'),
          name: '胡晓云',
          introduction: '浙江大学CARD中国农业品牌研究中心主任',
          jumpType: 2,
          linkAddress: 'https://www.example.com/guest/2'
        },
        {
          imageUrl: require('../assets/img/FigmaDDSSlicePNGa1953558fb341f2cea548f218709eada.png'),
          name: '李 伟',
          introduction: '《中国品牌》杂志社副社长',
          jumpType: 1,
          linkAddress: ''
        },
        {
          imageUrl: require('../assets/img/FigmaDDSSlicePNGa1953558fb341f2cea548f218709eada.png'),
          name: '王 芳',
          introduction: '中国区域农业品牌研究中心主任',
          jumpType: 2,
          linkAddress: 'https://www.example.com/guest/4'
        },
        {
          imageUrl: require('../assets/img/FigmaDDSSlicePNGa1953558fb341f2cea548f218709eada.png'),
          name: '刘 明',
          introduction: '品牌战略专家，长期致力于农业品牌研究与实践',
          jumpType: 1,
          linkAddress: ''
        }
      ]
    };
  },
  computed: {
    showcaseStyle() {
      return {
        backgroundColor: this.backgroundColor,
        width: '2000px',
        marginLeft: '-300px',
        padding: '20px 300px',
        boxSizing: 'border-box'
      };
    },
    titleGroupStyle() {
      return {
        margin: '0px auto 0',
        width: '360px',
        height: '70px',
        backgroundImage: `url(${this.titleBackgroundImage})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%',
        backgroundPosition: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      };
    }
  },
  methods: {
    handleClick(guest) {
      if (guest.jumpType !== 2 || !guest.linkAddress) return;
      window.open(guest.linkAddress, '_blank');
    }
  }
};
</script>

<style scoped>
.sp1-guest-showcase {
  width: 2000px;
  margin-left: -300px;
  padding: 0 300px;
  box-sizing: border-box;
  padding-top: 39px;
}

.sp1-group_69 .sp1-text_9 {
  margin: 0;
  width: auto;
  height: auto;
  text-align: center;
  line-height: 1;
}

.sp1-guest-list {
  justify-content: space-between;
  width: 1400px;
}

.sp1-guest-item {
  width: 237px;
  display: block;
  cursor: default;
  text-decoration: none;
  transition: opacity 0.2s;
}

.sp1-guest-item.is-link {
  cursor: pointer;
}

.sp1-guest-item.is-link:hover {
  opacity: 0.9;
}

.sp1-guest-item.is-link:hover .sp1-guest-name {
  color: #A00000;
  text-decoration: underline;
}

.sp1-guest-image {
  width: 237px;
  height: 260px;
  display: block;
  object-fit: cover;
}

.sp1-guest-text {
  width: 237px;
  margin-top: 23px;
}

.sp1-guest-name {
  color: #000000;
  font-size: 18px;
  font-family: Microsoft YaHei-Regular;
  line-height: 24px;
  text-align: left;
  white-space: nowrap;
}

.sp1-guest-intro {
  color: #B0B0B0;
  font-size: 14px;
  font-family: Microsoft YaHei-Regular;
  line-height: 22px;
  text-align: left;
  margin-top: 8px;
}
</style>
